import React from "react";
import { Box, Container, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import Logo from "../logo.svg";
import Language from "../components/language/Language";
import { Footer } from "./Footer";
import AdminSignIn from "../screens/admin-signin-v2/AdminSignIn";

export interface SignInLayoutProps {
  children: React.ReactNode;
}

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: "relative",
      overflowX: "hidden",
      overflowY: "auto",

      height: "98%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    headerContent: {
      padding: "0 20px",
      textAlign: "center",

      "& img": {
        display: "inline-block",
        width: 60,
        height: 60,
      },
    },

    wrapper: {
      padding: 0,
      maxWidth: 340,
    },

    layoutContent: {
      width: "100%",
      transition: "all .5s ease-out",

      margin: "20px 0",
    },

    languageWrapper: {
      padding: "20px 30px 16px 30px",
      borderRadius: 2,
      backgroundColor: theme.palette.common.white,
      margin: "20px 0",
      boxShadow: theme.shadows[1],

      "& a": {
        color: theme.palette.secondary.main,
        textDecoration: "none",
        fontSize: 13,
        fontWeight: theme.typography.fontWeightBold,

        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
  }),
  { name: "signin-layout-style", flip: null }
);

export default function SignInLayout(props: SignInLayoutProps) {
  const classes = useStyles(props);

  return (
    <>
      <Box component="div" className={classes.root}>
        <Container maxWidth={false} className={classes.wrapper}>
          <Box className={classes.headerContent}>
            <Link to="">
              <img src={Logo} alt="ICIP Logo" />
            </Link>
          </Box>
          <Box className={classes.layoutContent}>{props.children}</Box>
          <Box
            className={classes.languageWrapper}
            display="flex"
            alignContent="center"
            justifyContent="space-between"
          >
            <Link to={`${AdminSignIn.routeName}`}>
              <FormattedMessage id="sharedScreen.icipAdmin" />
            </Link>
            <Language />
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
